import React from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "../routes/ProtectedRoute";

// {Pages imports}
import LoginPage from "../pages/login";
import AdminDashboardPage from "../pages/Dashboard/AdminDashboardPage";
import WhatsNewCardView from "../pages/WhatNew/ViewAll";
import ManagerDashboardPage from "../pages/Dashboard/ManagerDashboardPage";
import UserDashboardPage from "../pages/Dashboard/UserDashboardPage";
import Users from "../pages/Users";
import PendingPayments from "../pages/PendingPayments";
import MyPaymentLeads from "../pages/MyPaymentLeads";
import MyLead from "../pages/MyLead";
import WhatsNew from "../pages/WhatNew/WhatsNew";
import SubscriptionExpires from "../pages/SubscriptionExpires";
import SubscriptionLead from "../pages/SubscriptionLead";
import MySubscriptionLeads from "../pages/MySubscriptionLeads";
import RagDocsDashboard from "../rag-docs-dashboard/rag-docs-dashboard";
import AiUsageDashboard from "../ai-usage-dashboard/ai-usage-dashboard";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />

      {/* Protected Routes */}
      <Route
        path="/adminDashboard"
        // element={<AdminDashboardPage/>}
        element={
          <ProtectedRoute
            element={AdminDashboardPage}
            allowedRoles={["admin"]}
          />
        }
      />
      <Route
        path="/userDashboard"
        // element={<UserDashboardPage/>}
        element={
          <ProtectedRoute
            element={UserDashboardPage}
            allowedRoles={["user"]}
          />
        }
      />
      <Route
        path="/managerDashboard"
        // element={<ManagerDashboardPage/>}
        element={
          <ProtectedRoute
            element={ManagerDashboardPage}
            allowedRoles={["admin", "manager"]}
          />
        }
      />
      <Route 
        path="/rag-docs-dashboard"
        element={
          <ProtectedRoute 
            element={RagDocsDashboard}
            allowedRoles={["admin", "manager", "user"]}
          />
        }
      />
      <Route
        path="/ai-usage"
        element={
          <ProtectedRoute
            element={AiUsageDashboard}
            allowedRoles={["admin", "manager", "user"]}
          />
        }
      />
      <Route
        path="/viewAll"
        // element={<WhatsNewCardView/>}
        element={
          <ProtectedRoute
            element={WhatsNewCardView}
            allowedRoles={["admin","manager"]}
          />
        }
      />
      <Route
        path="/whatsNew"
        element={<WhatsNew/>}
        allowedRoles={["admin","manager"]}
      />
      <Route
        path="/users"
        // element={<Users/>}
        element={
          <ProtectedRoute
            element={Users}
            allowedRoles={["admin"]}
          />
        }
      />
      <Route
        path="/payments"
        element={<PendingPayments/>}
      />
      <Route
        path="/payments-leads"
        element={<MyPaymentLeads/>}
      />
      <Route
        path="/payment-lead"
        element={<MyLead/>}
      />
      <Route
        path="/subscriptions"
        element={<SubscriptionExpires/>}
      />
      <Route
        path="/subscription-lead"
        element={<SubscriptionLead/>}
      />
      <Route
        path="/subscriptions-leads"
        element={<MySubscriptionLeads/>}
      />
    </Routes>
  );
};

export default AppRoutes;
